import { autoinject } from "aurelia-framework";
import { HttpClientRequestConfig } from "http-client/http-client-request-config";
import { PagingInfo } from "api/paging-info";
import { DispatchProjectTimeEntryProxy } from "api/proxies/dispatch-project-time-entry-proxy";
import { EquipmentModel } from "api/models/company/equipment/equipment-model";
import { DispatchProjectTimeEntriesSummaryResourceModel } from "api/models/company/project/dispatch/dispatch-project-time-entries-summary-resource-model";

@autoinject()
export class DispatchProjectTimeEntryService {
    constructor(private readonly dispatchProjectTimeEntryProxy: DispatchProjectTimeEntryProxy) {}

    public async GetSeperateTimeLinkedEquipmentDispatches(dispatchId: number, filter?: string, pagingInfo?: PagingInfo, requestConfig?: HttpClientRequestConfig): Promise<EquipmentModel[] | null> {
        return await this.dispatchProjectTimeEntryProxy.GetSeperateTimeLinkedEquipmentDispatches(dispatchId, filter, pagingInfo, requestConfig);
    }

    // Resume des heures d'une entree journaliere de projet (employes + equipements).
    // Meme remarque que DeleteAllTimeEntriesForDailyEntry : le proxy serialise la date via toString()
    // dans l'URL, on lui passe donc une date deja formatee (formatDateToSend), pas un objet Date.
    public async GetProjectTimeEntriesSummary(projectDispatchCode: string, dispatchDate: string, requestConfig?: HttpClientRequestConfig): Promise<DispatchProjectTimeEntriesSummaryResourceModel[] | null> {
        return await this.dispatchProjectTimeEntryProxy.GetProjectTimeEntriesSummary(projectDispatchCode, dispatchDate as any, undefined, undefined, requestConfig);
    }

    // Supprime toutes les entrees de temps (et bonus) d'une entree journaliere de projet.
    // Le proxy genere serialise le parametre de date via toString() dans l'URL : on lui passe
    // donc une date deja formatee (ex. formatDateToSend -> "YYYY-MM-DDTHH:mm:ss"), pas un objet Date.
    public async DeleteAllTimeEntriesForDailyEntry(projectDispatchCode: string, dispatchDate: string, requestConfig?: HttpClientRequestConfig): Promise<void> {
        await this.dispatchProjectTimeEntryProxy.DeleteAllTimeEntriesForDailyEntry(projectDispatchCode, dispatchDate as any, requestConfig);
    }
}
